<template>
  <div class="container-bg p-3 custom-scrollbar" style="height: 283px">
    <h3 class="text-center text-uppercase">
      <span v-if="isHome">Mijn</span> Taken
      <i
        v-if="canAddTask"
        class="fa fa-plus ml-3"
        @click="showCreateform"
        style="font-size: 24px; cursor: pointer"
      ></i>
    </h3>
    <div
      :class="{ done: task.active == 0 }"
      class="flex-container flex-body p-2 task"
      v-for="(task, index) in tasks"
      :key="'task_' + index"
    >
      <div class="item text-white" style="flex: 18 1 0%">
        <p style="margin: 0">{{ task.title }}</p>
      </div>
      <div class="item">
        <button
          v-if="task.public == 1 || isCommitteeMember || committee === null"
          @click="viewTask(task)"
          class="btn open-btn btn-primary bg-dark btn-sm mt-3"
        >
          Open
        </button>
      </div>
    </div>
    <!-- Task Modal -->
    <div
      class="modal fade"
      id="taskModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div
          class="modal-content px-2"
          :class="{ 'committee-modal': showDescriptionOnly }"
        >
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row" v-if="showDescriptionOnly">
              <div class="w-100">
                <p v-html="task.description"></p>
                <div>
                  <table class="table table-responsive">
                    <thead>
                      <tr class="text-white">
                        <th colspan="2">Verantwoordelijken:</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="text-white"
                        v-for="user in task.users"
                        :key="'task_user_' + user.id"
                      >
                        <td>
                          <img
                            style="
                              width: 55px;
                              border-radius: 50%;
                              background: lightgray;
                            "
                            :src="user.profile_image"
                            alt=""
                          />
                        </td>
                        <td>{{ user.display_name }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="d-flex justify-content-between">
                    <button class="btn-dark mt-3" @click="showEditForm">
                      Bewerken
                    </button>
                    <button class="btn-dark mt-3" @click="closeTasModal">
                      Annuleren
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <h5 class="text-uppercase">Maak Taak</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="row mt-3 ml-2">
                        <div class="col-lg-6">
                          <input
                            v-model="task.active"
                            id="activeevent"
                            class="form-check-input ml-1 mt-1"
                            type="checkbox"
                            value=""
                          />
                          <label for="activeevent" class="ml-4">Actief</label>
                        </div>
                        <div class="col-lg-6">
                          <input
                            v-model="task.public"
                            id="publicevent"
                            class="form-check-input ml-1 mt-1"
                            type="checkbox"
                            value=""
                          />
                          <label for="publicevent" class="ml-4">Publiek</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Titel</label>
                      <input
                        v-model="task.title"
                        type="text"
                        class="form-control"
                        id="name_add_task"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="textareacreatetask">Bericht:</label>
                      <editor
                        :id="'descriptionEditor2_' + task.id"
                        v-model="task.description"
                        :init="{
                          height: 200,
                          menubar: false,
                          language: 'nl',
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                                                alignleft aligncenter alignright alignjustify | \
                                                bullist numlist outdent indent | removeformat | help',
                        }"
                      />
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div
                      v-for="(file, index) in tasks_files"
                      :key="index"
                      class="row"
                    >
                      <div class="col-lg-1">
                        <img src="/assets/img/attach_blue.svg" alt="" />
                      </div>
                      <div class="col-lg-7">
                        <a
                          v-if="file.file_path"
                          :href="file.file_path"
                          target="_blank"
                        >
                          {{ file.file_name }}</a
                        >
                        <label v-else style="color: #4192d9">{{
                          file.filename
                        }}</label>
                      </div>
                      <div class="col-lg-3">
                        <a
                          @click="removeTaskFile(index, file)"
                          href="javascript:void(0)"
                          ><i
                            class="fa fa-trash"
                            style="color: red"
                            aria-hidden="true"
                          ></i
                        ></a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <input
                      type="file"
                      class="d-none"
                      @change="addTaskFile()"
                      id="task_file"
                    />
                    <button class="btn-dark float-right">
                      <label for="task_file">Voeg bestanden toe</label>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-5 col-12 pl-md-2 pr-md-5">
                <div class="row">
                  <div class="col-md-12 col-12 mb-3 p-0">
                    Commissies / Groepen:
                  </div>
                  <div class="col-md-12 col-12 pl-md-5 pt-4 pb-4 container-bg">
                    <div class="row">
                      <div
                        class="col-md-10 custom-scrollbar"
                        style="height: 200px"
                      >
                        <div
                          v-for="(comt, index) in taskCommittees"
                          :key="index"
                          class="form-check"
                        >
                          <input
                            v-model="comt.selected"
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            :id="'checkcomt_' + comt.id"
                          />
                          <label
                            class="form-check-label"
                            :for="'checkcomt_' + comt.id"
                          >
                            {{ comt.title }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 col-12 mb-3 p-0">
                    Verantwoordelijken:
                    <members></members>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 mt-3">
                <button class="btn-dark btn-outline float-left mt-3">
                  Annuleren
                </button>

                <button @click="createTask()" class="btn-dark float-right mt-3">
                  <span v-if="!savingTask">Opslaan</span>
                  <span v-else>Saving...</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Members from "./members.vue";

export default {
  components: {
    members: Members,
  },
  props: {
    committee: {
      type: Object,
      default: null,
    },
    committees: {
      type: Array,
    },
    isHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tasks: [],
      task: {
        active: true,
        public: true,
        description: "",
      },
      tasks_files: [],
      savingTask: false,
      showDescriptionOnly: false,
      canEditTask: false,
    };
  },
  methods: {
    getTasks() {
      if (this.committee) {
        this.getCommitteeTasks(!this.isCommitteeMember);
      } else {
        this.getUserTasks();
      }
    },

    getCommitteeTasks(onlyActive = false) {
      let link = onlyActive ? "task-active" : "task";

      this.$store
        .dispatch("get", "api/v1/committee/" + link + "/" + this.committee.id)
        .then((data) => {
          this.tasks = data.data;
        })
        .catch((error) => {
          error;
        });
    },
    getUserTasks() {
      this.$store
        .dispatch("get", "api/v1/get-user-task")
        .then((data) => {
          this.tasks = data.data.data;
        })
        .catch((error) => {
          error;
        });
    },
    viewTask(task) {
      this.task = task;
      this.canEditTask =
        task.users.some((user) => user.id == this.$store.state.auth.user.id) ||
        this.userHasPermissions(["Beheer Activiteiten"]);
      this.tasks_files = [];
      this.showDescriptionOnly = true;
      window.$("#taskModal").modal("show");
    },
    showEditForm() {
      this.$store.state.selectedMembers = this.task.users.map((user) => {
        return { id: user.id, text: user.display_name };
      });
      this.tasks_files = this.task.medias;
      this.showDescriptionOnly = false;
    },

    showCreateform() {
      this.task = {
        active: true,
        public: true,
        description: "",
      };
      this.tasks_files = [];
      this.showDescriptionOnly = false;
      this.$store.state.selectedMembers = [];

      window.$("#taskModal").modal("show");
    },

    addTaskFile() {
      var file = document.getElementById("task_file").files[0];
      var fileReader = new FileReader();
      fileReader.onload = (data) => {
        this.tasks_files.push({
          id: Math.round(Math.random() * 99999),
          filename: file.name,
          file: data.target.result,
        });
      };
      fileReader.readAsDataURL(file);
    },
    createTask() {
      let selected_committee_ids = this.taskCommittees
        .filter((d) => d.selected)
        .map((d) => d.id);
      let files = [...this.tasks_files];
      let task = this.task;
      let members = [...this.$store.state.selectedMembers.map((d) => d.id)];

      var formData = new FormData();
      formData.append(
        "selected_committees",
        JSON.stringify(selected_committee_ids)
      );
      formData.append("title", task.title);
      formData.append("body", task.description);
      formData.append("active", task.active);
      formData.append("public", task.public);
      formData.append("members", JSON.stringify(members));
      formData.append("files", JSON.stringify(files));

      let url = "api/v1/tasks";
      if (this.task.id) {
        url = "api/v1/committee/task/" + this.task.id;
        formData.append("_method", "PUT");
      }

      this.$store
        .dispatch("post", {
          endpoint: url,
          details: formData,
        })
        .then((data) => {
          if (this.task.id) {
            let ind = this.tasks.findIndex((t) => t.id === this.task.id);
            this.tasks.splice(ind, 1, data.data.data);
          } else {
            this.tasks.push(data.data.data);
          }

          this.$store.dispatch("auth/makeNotification", {
            status: "",
            statusText: "Opgeslagen",
          });
          this.showDescriptionOnly = true;
          window.$("#taskModal").modal("hide");
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    removeTaskFile(index, file) {
      if (file.file_path && file.id) {
        this.$store
          .dispatch("delete", "api/v1/task/delete-media/" + file.id)
          .then(() => {
            this.tasks_files.splice(index, 1);
          })
          .catch((error) => {
            error;
          });
      } else {
        this.tasks_files.splice(index, 1);
      }
    },
    closeTasModal() {
      window.$("#taskModal").modal("hide");
    },
  },
  mounted() {
    this.getTasks();
  },
  computed: {
    isCommitteeMember() {
      if (this.committee) {
        return this.committee.users.some(
          (user) => user.id == this.$store.state.auth.user.id
        );
      }
      return false;
    },
    canAddTask() {
      return (
        this.isCommitteeMember ||
        this.userHasPermissions(["Beheer Activiteiten"])
      );
    },
    taskCommittees() {
      return this.committees.map((com) => {
        return {
          id: com.id,
          selected:
            this.task.committee_pivot != null &&
            this.task.committee_pivot != undefined
              ? this.task.committee_pivot.some((p) => p.committee_id == com.id)
              : this.committee != null
              ? com.id == this.committee.id
              : false,
          title: com.title,
        };
      });
    },
  },
};
</script>

<style scoped>
.btn-small-mvn {
  font-size: 11px !important;
  padding: 3px 7px;
  border-radius: 3px !important;
  font-weight: lighter !important;
}
.open-btn {
  background: grey;
  border: none;
}
.task.done {
  background: black !important;
}

.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  padding: 0;
  border: unset;
}

.no-gutters {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.card-footer {
  border-top: unset;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;
  margin-top: 10px;
  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 0 auto;
  height: auto;
  margin: 4px;
  margin-right: 10px;
  padding: 10px 0;
  width: auto;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 900px;
    margin: 1.75rem auto;
    margin-top: 9rem;
  }

  .delete-modal {
    max-width: 600px !important;
    margin: 1.75rem auto;
  }
}

.form-control,
.input-group-text {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 4px;
  opacity: 1;
  border: 1px #ced4da;
}

.tab-styling {
  padding: 5px !important;
  font-size: 16px !important;
}

.active {
  background-color: #4192d9 !important;
  border: #4192d9;
}

.committee-modal {
  background: #4192d9;
  color: white;
}

.committee-modal button {
  background: black;
  color: white;
}
</style>
